module.exports = __webpack_public_path__ + "img/RORBPJR40018.a26ac254.svg";